import React from 'react';
import { Card, CardProps, styled, alpha } from '@mui/material';
import { glassmorphism } from '../../presentation/theme/dashboardTheme';

interface GlassCardProps extends CardProps {
  blur?: number;
  opacity?: number;
  gradient?: boolean;
}

const StyledGlassCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'blur' && prop !== 'opacity' && prop !== 'gradient',
})<GlassCardProps>(({ theme, blur = 10, opacity = 0.8, gradient }) => ({
  background: gradient
    ? `linear-gradient(135deg, ${alpha(theme.palette.background.paper, opacity)}, ${alpha(
        theme.palette.primary.main,
        0.05
      )})`
    : alpha(theme.palette.background.paper, opacity),
  backdropFilter: `blur(${blur}px)`,
  WebkitBackdropFilter: `blur(${blur}px)`,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(
      135deg,
      ${alpha(theme.palette.primary.main, 0.05)} 0%,
      transparent 60%
    )`,
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: `radial-gradient(
      circle,
      ${alpha(theme.palette.primary.main, 0.1)} 0%,
      transparent 70%
    )`,
    opacity: 0,
    transition: 'opacity 0.3s ease',
    pointerEvents: 'none',
  },
  '&:hover::after': {
    opacity: 1,
  },
}));

const GlassCard: React.FC<GlassCardProps> = ({ children, ...props }) => {
  return <StyledGlassCard {...props}>{children}</StyledGlassCard>;
};

export default GlassCard;